import { render, staticRenderFns } from "./SelectProductType.vue?vue&type=template&id=10e6cf44&scoped=true"
import script from "./SelectProductType.vue?vue&type=script&lang=ts"
export * from "./SelectProductType.vue?vue&type=script&lang=ts"
import style0 from "./SelectProductType.vue?vue&type=style&index=0&id=10e6cf44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6cf44",
  null
  
)

export default component.exports